module.exports = __webpack_public_path__ + "img/20190610.bce9919e.png";